import APIService from './APIService';

export default {
  getHistoricoConsultaConciliacaoAba(conciliacaoId, abaSelecionada) {
    return APIService.apiCall().get(
      `/conciliacao-consulta-aba/get-historico-consulta-conciliacao-aba/${conciliacaoId}/${abaSelecionada}`
    );
  },
  getTabelaColunas(conciliacaoId, abaSelecionada) {
    return APIService.apiCall().get(`/conciliacao-consulta-aba/get-tabela-colunas/${conciliacaoId}/${abaSelecionada}`);
  },
  getDadosAba(conciliacaoId, abaSelecionada, filtros = {}, limit = 1000) {
    const postData = { filtros, limit };
    return APIService.apiCall().post(
      `/conciliacao-consulta-aba/get-dados-aba/${conciliacaoId}/${abaSelecionada}`,
      JSON.stringify(postData)
    );
  },
  consultarAba(dadosConsulta) {
    return APIService.apiCall().post('/conciliacao-consulta-aba/consultar-aba', JSON.stringify(dadosConsulta));
  },
  baixarExtracao(id, config) {
    return APIService.apiCall().get(`/conciliacao-consulta-aba/download-consulta/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
